import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';
import React, { ComponentProps } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

export interface InputProps extends ComponentProps<'div'> {
  name: string;
  options: { value: string; label: { id: string } }[];
}

export const FormToggleButtonGroup = React.forwardRef(({ name, options }: InputProps, ref) => {
  const intl = useIntl();
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <>
          <ToggleButtonGroup {...field} ref={ref} className={'block'} color='primary' exclusive>
            {options.map((item, index) => (
              <ToggleButton key={`${item.value}_${index}`} value={item.value}>
                {intl.formatMessage(item.label)}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
          {error && (
            <FormHelperText error className={'ml-3'}>
              {error.message}
            </FormHelperText>
          )}
        </>
      )}
    />
  );
});

FormToggleButtonGroup.displayName = 'FormToggleButtonGroup';
